import { IconNames } from "@repo/core/components/core/Icon/types";
import {
  TransactionItemStatusEnum,
  TransactionItemTypeEnum
} from "@repo/core/constants/transactions";

export const TransactionItemInfoByType: Record<
  TransactionItemTypeEnum,
  { paymentName: string; icon: IconNames }
> = {
  [TransactionItemTypeEnum.COMPRA]: {
    paymentName: "Compra",
    icon: "credit-card"
  },
  [TransactionItemTypeEnum.PONTUACAO]: {
    paymentName: "Pontuação",
    icon: "credit-card"
  },
  [TransactionItemTypeEnum.PAGAMENTO]: {
    paymentName: "Pagamento",
    icon: "wallet"
  },
  [TransactionItemTypeEnum.SAQUE]: {
    paymentName: "Saque Emergencial (Crédito)",
    icon: "sack-dollar"
  }
};

export const TransactionItemInfoByStatus: Record<
  TransactionItemStatusEnum,
  {
    showStatus: boolean;
    statusColor: string;
    statusName?: string;
  }
> = {
  [TransactionItemStatusEnum.ATIVO]: {
    showStatus: false,
    statusColor: "$primary600"
  },
  [TransactionItemStatusEnum.DESFEITO]: {
    showStatus: false,
    statusColor: "$primary600"
  },
  [TransactionItemStatusEnum.CANCELADO]: {
    showStatus: true,
    statusColor: "$error500",
    statusName: "Cancelada"
  },
  [TransactionItemStatusEnum.QUESTIONADA]: {
    showStatus: true,
    statusColor: "$error500",
    statusName: "Cancelada"
  },
  [TransactionItemStatusEnum.PENDENTE]: {
    showStatus: true,
    statusColor: "$warning500",
    statusName: "Pendente"
  },
  [TransactionItemStatusEnum.LIQUIDADO]: {
    showStatus: true,
    statusColor: "$primary600",
    statusName: "Liquidado"
  },
  [TransactionItemStatusEnum.ESTORNADO]: {
    showStatus: true,
    statusColor: "$primary600",
    statusName: "Estornado"
  }
};
